import React from "react";

function NoClass(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 119 118" {...props}>
      <g filter="url(#NoClass__filter0_dd)">
        <path
          fill="#F6F8FA"
          d="M112.198 9.313L13.406 2.9a2 2 0 00-2.125 1.866l-6.347 97.795a2 2 0 001.866 2.125l98.792 6.412a2 2 0 002.125-1.867l6.347-97.794a2 2 0 00-1.866-2.125z"></path>
      </g>
      <path
        fill="#E4E4E4"
        d="M103.375 21.767a1 1 0 101.995.13 1 1 0 00-1.995-.13zm-2.994-.194a1 1 0 101.996.13 1 1 0 00-1.996-.13zm-2.995-.194a1 1 0 101.996.13 1 1 0 00-1.996-.13zM41.377 96.91l-27.942-1.813-.129 1.996 27.941 1.813.13-1.996zm33.319-3.85l-60.872-3.95-.259 3.991 60.872 3.95.26-3.991z"></path>
      <rect
        width="11"
        height="11"
        x="18.875"
        y="11.273"
        fill="#005EE9"
        fillOpacity="0.3"
        rx="2"
        transform="rotate(3.713 18.875 11.273)"></rect>
      <g filter="url(#NoClass__filter1_dd)">
        <path
          fill="#F6F8FA"
          d="M107.073 4.199L8.141 7.87a2 2 0 00-1.924 2.073l3.634 97.933a2 2 0 002.073 1.924l98.932-3.671a2 2 0 001.924-2.073l-3.634-97.933a2 2 0 00-2.073-1.924z"></path>
      </g>
      <path
        fill="#E4E4E4"
        d="M99.56 17.487a1 1 0 102-.075 1 1 0 00-2 .075zm-2.997.111a1 1 0 101.998-.074 1 1 0 00-1.999.074zm-2.999.112a1 1 0 101.999-.075 1 1 0 00-1.999.074zM45.53 98.546l-27.981 1.038.074 1.999 27.98-1.039-.073-1.998zm32.754-7.219l-60.958 2.262.148 3.997 60.959-2.262-.149-3.997z"></path>
      <rect
        width="11"
        height="11"
        x="14.434"
        y="15.643"
        fill="#005EE9"
        fillOpacity="0.3"
        rx="2"
        transform="rotate(-2.125 14.434 15.643)"></rect>
      <g filter="url(#NoClass__filter2_dd)">
        <path fill="#F6F8FA" d="M109 6H10a2 2 0 00-2 2v98a2 2 0 002 2h99a2 2 0 002-2V8a2 2 0 00-2-2z"></path>
        <path fill="url(#NoClass__paint0_linear)" d="M109 6H10a2 2 0 00-2 2v98a2 2 0 002 2h99a2 2 0 002-2V8a2 2 0 00-2-2z"></path>
      </g>
      <path
        fill="#E4E4E4"
        d="M101 19a1 1 0 102 0 1 1 0 00-2 0zm-3 0a1 1 0 102 0 1 1 0 00-2 0zm-3 0a1 1 0 102 0 1 1 0 00-2 0zM44 98H16v2h28v-2zm33-6H16v4h61v-4z"></path>
      <rect width="11" height="11" x="16" y="14" fill="#005EE9" fillOpacity="0.3" rx="2"></rect>
      <defs>
        <filter
          id="NoClass__filter0_dd"
          width="117.39"
          height="116.457"
          x="0.805"
          y="0.771"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse">
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
          <feOffset></feOffset>
          <feGaussianBlur stdDeviation="0.5"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"></feColorMatrix>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
          <feOffset dy="2"></feOffset>
          <feGaussianBlur stdDeviation="2"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"></feColorMatrix>
          <feBlend in2="effect1_dropShadow" result="effect2_dropShadow"></feBlend>
          <feBlend in="SourceGraphic" in2="effect2_dropShadow" result="shape"></feBlend>
        </filter>
        <filter
          id="NoClass__filter1_dd"
          width="114.712"
          height="113.749"
          x="2.143"
          y="2.125"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse">
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
          <feOffset></feOffset>
          <feGaussianBlur stdDeviation="0.5"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"></feColorMatrix>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
          <feOffset dy="2"></feOffset>
          <feGaussianBlur stdDeviation="2"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"></feColorMatrix>
          <feBlend in2="effect1_dropShadow" result="effect2_dropShadow"></feBlend>
          <feBlend in="SourceGraphic" in2="effect2_dropShadow" result="shape"></feBlend>
        </filter>
        <filter id="NoClass__filter2_dd" width="111" height="110" x="4" y="4" colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse">
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
          <feOffset></feOffset>
          <feGaussianBlur stdDeviation="0.5"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"></feColorMatrix>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
          <feOffset dy="2"></feOffset>
          <feGaussianBlur stdDeviation="2"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"></feColorMatrix>
          <feBlend in2="effect1_dropShadow" result="effect2_dropShadow"></feBlend>
          <feBlend in="SourceGraphic" in2="effect2_dropShadow" result="shape"></feBlend>
        </filter>
        <linearGradient id="NoClass__paint0_linear" x1="8" x2="110" y1="6" y2="108" gradientUnits="userSpaceOnUse">
          <stop stopColor="#fff"></stop>
          <stop offset="1" stopColor="#EBEBEB"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default NoClass;